import { useLanguage } from '../hooks/useLanguage';
import { UI_TEXT } from './uiText';
import { CONTENT_ES } from './contentEs';

// t() covers interface chrome (nav, settings, buttons) via symbolic keys.
// tc() covers built-in stimulus content (flashcard/sequencing text) by exact
// English string — falls back to the original English if untranslated
// (e.g. Firestore-authored custom decks, which have no Spanish source).
export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key) => UI_TEXT[key]?.[language] ?? UI_TEXT[key]?.en ?? key;
  const tc = (text) => (language === 'es' ? (CONTENT_ES[text] || text) : text);

  return { t, tc, language };
};
